var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29 11.29L11.29 7.29C11.5437 7.03634 11.9134 6.93728 12.2599 7.03012C12.6064 7.12297 12.877 7.39362 12.9699 7.74012C13.0627 8.08663 12.9637 8.45634 12.71 8.71L10.41 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H10.41L12.71 15.29C12.8993 15.4778 13.0058 15.7334 13.0058 16C13.0058 16.2666 12.8993 16.5222 12.71 16.71C12.5222 16.8993 12.2666 17.0058 12 17.0058C11.7334 17.0058 11.4778 16.8993 11.29 16.71L7.29 12.71C7.19896 12.6149 7.12759 12.5028 7.08 12.38C6.97998 12.1365 6.97998 11.8635 7.08 11.62C7.12759 11.4972 7.19896 11.3851 7.29 11.29ZM4 4C4.55229 4 5 4.44772 5 5V19C5 19.5523 4.55229 20 4 20C3.44772 20 3 19.5523 3 19V5C3 4.44772 3.44772 4 4 4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default ForwardRef;